import entityContainerConnector from '~components/generic/entityContainerConnector';
import { DraggableModule } from '~components/generic/module/DraggableModule';

export default entityContainerConnector(DraggableModule);
